"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRACK_TYPES = exports.defaultOptions = void 0;
exports.defaultOptions = {
  urlBase: null,
  siteId: 1
};
exports.TRACK_TYPES = {
  TRACK_EVENT: 'trackEvent',
  TRACK_LINK: 'trackLink',
  TRACK_SEARCH: 'trackSiteSearch',
  TRACK_VIEW: 'trackPageView',
  TRACK_ECOMMERCE_ORDER: 'trackEcommerceOrder',
  TRACK_ECOMMERCE_CART_UPDATE: 'trackEcommerceCartUpdate'
};